import { render, staticRenderFns } from "./add_activity.vue?vue&type=template&id=67b22375&scoped=true"
import script from "./add_activity.vue?vue&type=script&lang=js"
export * from "./add_activity.vue?vue&type=script&lang=js"
import style0 from "./add_activity.vue?vue&type=style&index=0&id=67b22375&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b22375",
  null
  
)

export default component.exports